import { cn } from '@vidahealth/vida-ui';
import { ActivityIndicator, View } from 'react-native';

// A semi-transparent scrim + centered spinner that fills its nearest positioned
// ancestor (`absolute inset-0`). Unlike LoadingScreen (an opaque full-screen
// placeholder shown *instead* of content), this overlays existing content to
// signal an in-flight action — e.g. a slow save — while keeping the screen
// visible (dimmed) behind it. The `bg-*/40` alpha colors only the View's own
// background, so the spinner stays fully opaque. `onStartShouldSetResponder`
// claims touches so the underlying form can't be interacted with mid-request.
export function LoadingOverlay({ className }: { className?: string }) {
  return (
    <View
      className={cn('absolute inset-0 items-center justify-center bg-background-0/40', className)}
      onStartShouldSetResponder={() => true}
    >
      <ActivityIndicator size='large' />
    </View>
  );
}
